import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';
import { queryKeys } from '../../../api/queryKeys';
import {
  fetchLatestDriverLocations,
  fetchLatestStaffLocations,
  fetchDriverLocationHistory,
} from '../../../api/driverLocations';

export function useLatestDriverLocations() {
  const query = useQuery({
    queryKey: queryKeys.driverLocations.latest(),
    queryFn: fetchLatestDriverLocations,
    refetchInterval: 30_000,
    staleTime: 25_000,
  });

  useEffect(() => {
    if (query.error) {
      console.error('[useLatestDriverLocations] fetch failed:', query.error);
    }
  }, [query.error]);

  return query;
}

export function useLatestStaffLocations() {
  const query = useQuery({
    queryKey: queryKeys.staffLocations.latest(),
    queryFn: fetchLatestStaffLocations,
    refetchInterval: 30_000,
    staleTime: 25_000,
  });

  useEffect(() => {
    if (query.error) {
      console.error('[useLatestStaffLocations] fetch failed:', query.error);
    }
  }, [query.error]);

  return query;
}

export function useDriverLocationHistory(encDriverId: string, date: string) {
  return useQuery({
    queryKey: queryKeys.driverLocations.history(encDriverId, date),
    queryFn: () => fetchDriverLocationHistory(encDriverId, date),
    enabled: !!encDriverId,
    staleTime: 60_000,
  });
}
